import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
  showLoading = false;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/global/loading.service.ts